const imgUrl = 'http://www.guenyanglao.com/'

export default{
    imgUrl
}


// WEBPACK FOOTER //
// ./src/api/global.js